var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"vue-loading-animation"},[_c('div',{staticClass:"circle circle-1",style:({ 'border-top-color': _vm.Color })}),_c('div',{staticClass:"circle circle-2",style:({ 'border-bottom-color': _vm.Color })})])
}
var staticRenderFns = []

export { render, staticRenderFns }